import {request} from '../utils/request';

/**
 * 获取用户租户分页列表
 * @param {Object} data - 查询参数
 */
export const getUserTenantPageList = (data) => {
  return request({
    url: '/UserTenant/GetPageList',
    method: 'post',
    data,
  });
};

/**
 * 获取用户租户详情
 * @param {number} id - 用户租户ID
 */
export const getUserTenantDetail = (id) => {
  return request({
    url: '/UserTenant/GetDetail',
    method: 'get',
    params: { id },
  });
};

/**
 * 添加用户租户
 * @param {Object} data - 用户租户数据
 */
export const addUserTenant = (data) => {
  return request({
    url: '/UserTenant/Add',
    method: 'post',
    data,
  });
};

/**
 * 更新用户租户
 * @param {Object} data - 用户租户数据
 */
export const updateUserTenant = (data) => {
  return request({
    url: '/UserTenant/Update',
    method: 'post',
    data,
  });
};

/**
 * 更新用户租户状态
 * @param {Object} data - 状态数据
 * @param {number} data.Status - 状态
 * @param {Array<number>} data.Ids - 用户租户ID数组
 */
export const updateUserTenantStatus = (data) => {
  return request({
    url: '/UserTenant/UpdateStatus',
    method: 'post',
    data,
  });
};
